import React, { Component } from 'react';
import { Row, Col, Card, CardHeader, CardBody, Collapse } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';

class Accordion extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false //this.props.data.length > 0 ? this.props.data[0].title : null
        }
    }

    showHide(id) {
        this.setState({
            open: (id === this.state.open) ? null : (this.props.data.findIndex(row => row.title === id) > -1 ? id : this.props.data[0].title)
        })
    }

    render() {
        return (<>
            {this.props.data.map(row => (
                <Card key={row.title} className="mb-0 w-100 rounded-0">
                    <CardHeader onClick={() => this.showHide(row.title)} className={'py-1 pointer' + (this.state.open === row.title ? " activeTabHeader" : "")}>
                        <Row className="align-items-center py-0">
                            <Col sm={10} className="text-left py-0">
                                <div className='font-weight-bold'>
                                    {row.title}
                                </div>
                            </Col>
                            <Col sm={2} className="text-right py-0">
                                <div>
                                    {row.subinfo}
                                </div>
                            </Col>
                        </Row>
                    </CardHeader>
                    <Collapse isOpen={this.state.open === row.title}>
                        <CardBody>
                            {row.component(row.data)}
                        </CardBody>
                    </Collapse>
                </Card>

            ))}
        </>
        )
    }
};

export default Accordion;